import { createTheme } from "@mui/material/styles";

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });

const theme = createTheme({
    typography: {
        fontFamily: "Poppins",
    },
    components: {
        MuiTextField: {
            defaultProps: {
                variant: "filled",
                size: "small"
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    '&:before, &:after': {
                        display: 'none'
                    },
                    border: "1px solid lightgrey",
                    borderRadius: 5,

                    fontSize: '13px',
                    fontWeight: 500,
                    height: '40px',

                }
            },
        },
        MuiInputLabel: {
            defaultProps: {
                shrink: true,
            },
            styleOverrides: {
                root: {
                    fontSize: '12px',
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                option: {
                    fontSize: '13px'
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: '13px'
                },
            },
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true,
                variant: "contained",
            },
            styleOverrides: {
                root: {
                    textTransform: "none",
                    paddingLeft: 30,
                    paddingRight: 30,
                    fontWeight: 400,
                    color: "black",
                    backgroundColor: "#b5dcf2"
                },

            }
        },
        MuiToggleButtonGroup: {
            defaultProps: {
                size: "small",
                exclusive: true
            }
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    backgroundColor: "lightgrey"
                }
            }
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        // MuiChip: {
        //     defaultProps: {
        //         size: "small"
        //     }
        // },
        // MuiFab: {
        //     defaultProps: {
        //         size: "small",
        //         disableRipple: true,
        //     }
        // },
        MuiCssBaseline: {
            styleOverrides: {
                "*": {
                    scrollbarWidth: "thin",
                    scrollbarColor: "#bdbdbd transparent",
                },

                "*::-webkit-scrollbar": {
                    width: "5px",
                    height: "5px",
                },

                "*::-webkit-scrollbar-thumb": {
                    backgroundColor: "#bdbdbd",
                    borderRadius: "10px",
                },

                "*::-webkit-scrollbar-track": {
                    backgroundColor: "transparent",
                },
            },
        },
    },
})


export default theme;
